import 'nodelist-foreach-polyfill';
import 'mdn-array-from';
import 'promise-polyfill/src/polyfill';
import 'url-search-params-polyfill';
import 'custom-event-polyfill';
import 'whatwg-fetch';
import 'intersection-observer';
import './polyfills/scope';
import './polyfills/childnodeRemove';
import './polyfills/childnodeRemove';

import 'picturefill';

var templatePolyfill = require('template-polyfill');
templatePolyfill();

require('es6-object-assign').polyfill();

require.context('./styles/lib', true, /\.(css)$/);
require.context('./styles/global', true, /\.(css)$/);
require.context('./assets/icons', true, /\.(css)$/);
require.context('./styles/patterns', true, /\.(css)$/);
require.context('./modules', true, /\.(css)$/);
require.context('./styles/framework', true, /\.(css)$/);
require.context('./styles/views', true, /\.(css)$/);

const modules = require.context('./modules', true, /\.(js)$/);
modules.keys().forEach(modules);

import './global/removeOutlines';
import './global/links';
import './global/wrapTables';

import svg4everybody from 'svg4everybody';

svg4everybody({
  nosvg: true,
  polyfill: false
});

import objectFitImages from 'object-fit-images';
objectFitImages();

import objectFitVideos from 'object-fit-videos';
objectFitVideos();
